import { NavIcon } from '@/components/icons/NavIcon';
import styles from './FilterSelect.module.css';

export interface FilterOption {
  value: string;
  label: string;
}

interface FilterSelectProps {
  label: string;
  value: string;
  options: FilterOption[];
  onChange: (next: string) => void;
}

export function FilterSelect({ label, value, options, onChange }: FilterSelectProps) {
  return (
    <div className={styles.wrap}>
      <span className={styles.label}>{label}</span>
      <span className={styles.divider} />
      <div className={styles.selectWrap}>
        <select
          className={styles.select}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <span className={styles.chev} aria-hidden>
          <NavIcon name="chev-d" size={13} />
        </span>
      </div>
    </div>
  );
}
